// Výřez z FofrLamaPOS lib/ui.js a lib/posUi.js — jen to, co editor stolů
// potřebuje. Barvy jsou CSS proměnné pokladny; ve Správě je nastavuje
// obal editoru (EditorStoluSprava), ať se nepletou se zbytkem OS.
import { Receipt, CalendarClock, Brush } from 'lucide-react'
import IkonaStolu from './IkonaStolu'

export const COLORS = {
  brand: 'var(--brand)',
  surfaceBase: 'var(--surface-base)',
  surfaceRaised: 'var(--surface-raised)',
  surfaceElevated: 'var(--surface-elevated)',
  borderSubtle: 'var(--border-subtle)',
  borderDefault: 'var(--border-default)',
  borderStrong: 'var(--border-strong)',
  textPrimary: 'var(--text-primary)',
  textSecondary: 'var(--text-secondary)',
  textMuted: 'var(--text-muted)',
  textTertiary: 'var(--text-tertiary)',
  textInverse: 'var(--text-inverse)',
  busy: 'var(--busy)',
  danger: 'var(--danger)',
  info: 'var(--info)',
  success: 'var(--success)',
  tyrkys: 'var(--tyrkys)',
}

export function hexToRgba(barva, alpha = 1) {
  if (typeof barva !== 'string') return barva
  if (alpha >= 1) return barva
  return `color-mix(in srgb, ${barva} ${Math.round(alpha * 1000) / 10}%, transparent)`
}

export const INPUT_STYLE = {
  background: 'rgba(var(--tint-rgb),0.06)',
  border: '1px solid rgba(var(--tint-rgb),0.10)',
  color: COLORS.textPrimary,
  borderRadius: 8,
  minHeight: 44,
  padding: '10px 12px',
  fontSize: 13,
  width: '100%',
  outline: 'none',
}

export const STAV_STOLU = {
  volny: { label: 'Volný', color: COLORS.textMuted, icon: null },
  obsazeny: { label: 'Obsazený', color: 'var(--kanal-bistro)', icon: IkonaStolu },
  ceka_na_ucet: { label: 'Čeká na účet', color: COLORS.busy, icon: Receipt },
  k_uklidu: { label: 'K úklidu', color: 'var(--tyrkys)', icon: Brush },
  rezervovany: { label: 'Rezervace', color: COLORS.info, icon: CalendarClock },
}

export function stavStoluConfig(stav) {
  return STAV_STOLU[stav] ?? STAV_STOLU.volny
}

export function barvaUklidu(uklid) {
  return uklid?.eskalace ? COLORS.danger : STAV_STOLU.k_uklidu.color
}

export function kc(hodnota) {
  const n = Number(hodnota ?? 0)
  const desetiny = Math.round(n * 100) % 100 !== 0
  return n.toLocaleString('cs-CZ', { minimumFractionDigits: desetiny ? 2 : 0, maximumFractionDigits: 2 }) + ' Kč'
}

export function cas(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' })
}

export function tlacitkoStyle(barva, { plne = false, disabled = false } = {}) {
  return {
    background: disabled ? 'rgba(var(--tint-rgb),0.03)' : plne ? barva : hexToRgba(barva, 0.13),
    border: `1px solid ${disabled ? COLORS.borderDefault : plne ? barva : hexToRgba(barva, 0.33)}`,
    color: disabled ? COLORS.textMuted : plne ? COLORS.textInverse : barva,
    borderRadius: 12,
    fontWeight: 700,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.12s ease',
  }
}
